/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Link,
} from "@mui/material";
import api from "../../api";

const RecoverPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (!validateEmail(value)) {
      setError("E-mail inválido.");
    } else {
      setError("");
    }
  };

  const handleRecoverPassword = async () => {
    if (validateEmail(email)) {
      try {
        const response = await api.post("/auth/recover-password", { email });

        // Define a mensagem de sucesso
        setSuccessMessage("Instruções enviadas para o e-mail fornecido.");
        setError("");

        // Limpa mensagens anteriores antes de configurar um novo timeout
        clearTimeout(window.messageTimeout);

        // Define um timeout para limpar a mensagem
        window.messageTimeout = setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
      } catch (error) {
        setError("Erro ao enviar instruções. Tente novamente.");
        setSuccessMessage("");

        clearTimeout(window.messageTimeout);

        // Define um timeout para limpar o erro
        window.messageTimeout = setTimeout(() => {
          setError("");
        }, 3000);
      }
    } else {
      setError("Por favor, insira um e-mail válido.");

      clearTimeout(window.messageTimeout);

      // Define um timeout para limpar o erro
      window.messageTimeout = setTimeout(() => {
        setError("");
      }, 3000);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4, textAlign: "center" }}>
      <Typography variant="h4" gutterBottom>
        Recuperar Senha
      </Typography>

      <Box sx={{ mt: 2 }}>
        <TextField
          label="E-mail"
          variant="outlined"
          fullWidth
          value={email}
          onChange={handleEmailChange}
          error={!!error}
          helperText={
            error && (
              <span style={{ color: "red", fontWeight: "bold" }}>{error}</span>
            )
          }
          sx={{ mb: 2 }}
        />
        {successMessage && (
          <Typography
            sx={{
              color: "green",
              fontWeight: "bold",
              mt: 2,
              textAlign: "center",
            }}
          >
            {successMessage}
          </Typography>
        )}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          onClick={handleRecoverPassword}
          disabled={!email || !!error}
        >
          Enviar Instruções
        </Button>
        <Box sx={{ mt: 2 }}>
          <Link href="/login" underline="hover">
            Voltar para o Login
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default RecoverPassword;
